import { render, staticRenderFns } from "./kTojIndex.vue?vue&type=template&id=4af98312&scoped=true&"
import script from "./kTojIndex.vue?vue&type=script&lang=js&"
export * from "./kTojIndex.vue?vue&type=script&lang=js&"
import style0 from "./kTojIndex.vue?vue&type=style&index=0&id=4af98312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af98312",
  null
  
)

export default component.exports